import React, { useEffect, useState } from 'react';
import { Form, InputNumber, Select } from 'antd';

import { isArray, isEmpty } from 'lodash';

import { renderNoDataOrSpinner } from '../../../shared/utils';
import * as mappingConstants from '../store/constants/mapping-constants';

const FieldItem = ({
  rootContainer,
  originalMappingObjects,
  level,
  mappingNameForm,
  skipRequired,
  setUserObjectType,
  currentMappedField,
  setCurrentMappedField,
  isPreview,
  insuredMappingExists,
  prospectMappingExists,
  policyMappingExists,
  quoteMappingExists,
}) => {
  const [hasPosition, setHasPosition] = useState(false);
  const [hasChild, setHasChild] = useState(false);
  const [childData, setChildData] = useState([]);
  const [selectedValue, setSelectedValue] = useState();

  const positionFieldName = mappingConstants.POSITION_FIELD_NAME + level;
  const objectFieldName = mappingConstants.OBJECT_FIELD_NAME + level;

  useEffect(() => {
    setHasPosition(selectedValue?.hasPosition ?? false);
    setHasChild(isArray(selectedValue?.childMappings));
    setChildData(selectedValue?.childMappings ?? []);

    if (typeof setUserObjectType == 'function') {
      setUserObjectType(selectedValue?.type);
    }
  }, [selectedValue]);

  useEffect(() => {
    setSelectedValue();

    if (typeof setUserObjectType == 'function') {
      setUserObjectType();
    }

    mappingNameForm.setFieldsValue({
      [positionFieldName]: undefined,
      [objectFieldName]: undefined,
    });
  }, [originalMappingObjects]);

  useEffect(() => {
    if (currentMappedField) {
      onChange(currentMappedField.objectKey);
      mappingNameForm.setFieldsValue({
        [positionFieldName]: currentMappedField.objectPosition ?? 0,
        [objectFieldName]: currentMappedField.objectKey,
      });
    } else {
      mappingNameForm.setFieldsValue({
        [positionFieldName]: 0,
      });
    }
  }, []);

  const onChange = (value) => {
    const selectedVal = originalMappingObjects.find((x) => x.objectKey == value);

    setSelectedValue(selectedVal);
  };

  return (
    <>
      <Form.Item className="mapping-item">
        <Form.Item
          name={objectFieldName}
          style={{ width: '100%', marginRight: hasPosition ? '8px' : 0 }}
          rules={[
            () => ({
              validator: (_, value) => {
                return !isEmpty(value) || skipRequired ? Promise.resolve() : Promise.reject('This field is required.');
              },
            }),
          ]}
          disabled={isPreview}
        >
          <Select
            getPopupContainer={rootContainer}
            allowClear
            showSearch
            showArrow
            placeholder="Object Name"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={onChange}
            onClick={setCurrentMappedField}
            notFoundContent={renderNoDataOrSpinner(false)}
            disabled={isPreview}
          >
            {originalMappingObjects && originalMappingObjects.length
              ? originalMappingObjects.map((option) => (
                  <Select.Option
                    key={option.objectKey}
                    value={option.objectKey}
                    title={option.objectName}
                    disabled={
                      (option.objectName === 'Insured' && prospectMappingExists) ||
                      (option.objectName === 'Prospect' && insuredMappingExists) ||
                      (option.objectName === 'Policy' && quoteMappingExists) ||
                      (option.objectName === 'Quote' && policyMappingExists)
                    }
                  >
                    {option.objectName}
                  </Select.Option>
                ))
              : null}
          </Select>
        </Form.Item>

        {hasPosition ? (
          <Form.Item name={positionFieldName} style={{ width: '50px' }} rules={[{ required: true, message: 'Please input the position.' }]}>
            <InputNumber min={0} max={999} placeholder="Position" disabled={isPreview} />
          </Form.Item>
        ) : null}
      </Form.Item>

      {hasChild ? (
        <FieldItem
          rootContainer={rootContainer}
          originalMappingObjects={childData}
          level={level + 1}
          mappingNameForm={mappingNameForm}
          currentMappedField={currentMappedField?.childMapping}
          setCurrentMappedField={setCurrentMappedField}
          isPreview={isPreview}
        />
      ) : null}
    </>
  );
};

export default FieldItem;
